module.exports = __webpack_public_path__ + "static/team_yogesh-3f302362fcd2f88132757dc901015ffb.jpeg";